import { useEffect } from "react";
import MehfoozExpress from "./MefooozExpress";
import EconomyExpress from "./EconomyExpress";
import LiquidShipping from "./LiquidShipping";
import MMS from "./MMS";
import SameDayDelivery from "./SameDayDelivery";
import SecondDayDelivery from "./SecondDayDelivery";
import TimeChoiceDelivery from "./TimeChoiceDelivery";
import COD from "./COD";
import Distribution from "./Distribution";
import ColdChain from "./ColdChain";
import PackNGO from "./Packngo";
import Warehouse from "./Warehouse";
import OverNight from "./OverNight";
import { Link } from "react-router-dom";
import RedBox from "./RedBox";
import ExpressFlyer from "./ExpressFlyer";
import StudentExpress from "./StudentExpress";
import AttestationServices from "./AttestationServices";
import TicketingServices from "./TicketingServices";
import PaymentSolution from "./PaymentSolution";
import ShipmentInsurance from "./ShipmentInsurance";
import TCSFresh from "./TCSFresh";
import EcomSolution from "./EcomSolution";
import OverlandExpress from "./OverlandExpress";

const Domestic = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false,
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false,
  );

  return (
    <div>
      <div className="domestic-image">
        <img
          src="/DomesticScrollingBanner/domestic-main-banner.jpg"
          alt=""
          className="w-[100%] "
        />
      </div>
      <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
        <p>
          Our domestic operations are what makes us the leader in Pakistan’s
          courier and logistics industry. Facilitating walk-in customers at our
          Express Centres across Pakistan, we cater for the largest customer
          base in the country, with an endless range of cost-effective
          solutions, such as domestic and international shipments of documents
          and parcels, document attestation, visa dropbox, branchless banking,
          fulfilment services and everything in-between. Our round the clock
          domestic operations with retail teams, the largest delivery fleet and
          our service standards give our individual and business customers peace
          of mind while setting the bar for all courier and logistics companies
          in Pakistan.
        </p>

        <div className="MuiFormGroup-root MuiFormGroup-row">
          <div className="lg:flex md:flex sm:flex grid pb-[50px]">
            <div className="lg:flex-1 md:flex-1 sm:flex-1 lg:flex lg:flex-col ">
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/overnight" className="font-bold">
                    Overnight Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/samedaydelivery" className="font-bold">
                    Same Day Delivery
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/2nddaydelivery" className="font-bold">
                    2nd Day Delivery
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/timechoicedelivery" className="font-bold">
                    Time Choice Delivery
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/redbox" className="font-bold">
                    RedBox
                  </Link>
                </li>
              </div>

              <div className="flex items-center">
                <li>
                  <Link to="/domestic/economyexpress" className="font-bold">
                    Economy Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/distribution" className="font-bold">
                    Distribution
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/Warehousing" className="font-bold">
                    Warehousing
                  </Link>
                </li>
              </div>
            </div>

            <div className="flex-1 flex flex-col">
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/expressflyer" className="font-bold">
                    Express Flyer
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/mehfoozexpress" className="font-bold">
                    Mehfooz Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/liquidshipping" className="font-bold">
                    Liquid Shipments
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/studentexpress" className="font-bold">
                    Students Express
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link
                    to="/domestic/attestationservices"
                    className="font-bold"
                  >
                    Attestation Services
                  </Link>
                </li>
              </div>
              <div className="flex items-center ">
                <li>
                  <Link to="/domestic/ticketingservices" className="font-bold">
                    Ticketing Services
                  </Link>
                </li>
              </div>

              <div className="flex items-center">
                <li>
                  <Link to="/domestic/pack-n-go" className="font-bold">
                    PackNGo
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/overlandexpress" className="font-bold">
                    Overland Express
                  </Link>
                </li>
              </div>
            </div>

            <div className="flex-1 flex flex-col">
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/retail_cod" className="font-bold">
                    Retail COD
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/paymentsolution" className="font-bold">
                    Payment Solutions
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/shipmentinsurance" className="font-bold">
                    Shipment Transit Insurance
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/tcsfresh" className="font-bold">
                    TCS Fresh
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/ecomsolution" className="font-bold">
                    E-com Solutions
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/mms" className="font-bold">
                    Mailroom Management
                  </Link>
                </li>
              </div>
              <div className="flex items-center">
                <li>
                  <Link to="/domestic/coldchain" className="font-bold">
                    Cold Chain Management
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-[2rem] sm:mx-[2rem] md:mx-[2rem]  lg:mx-[auto]">
        <div id="overnight">
          <OverNight />
        </div>
        <div id="samedaydelivery">
          <SameDayDelivery />
        </div>
        <div id="2nddaydelivery">
          <SecondDayDelivery />
        </div>
        <div id="timechoicedelivery">
          <TimeChoiceDelivery />
        </div>
        <div id="redbox">
          <RedBox />
        </div>
        <div id="economyexpress">
          <EconomyExpress />
        </div>
        <div id="expressflyer">
          <ExpressFlyer />
        </div>
        <div id="mehfoozexpress">
          <MehfoozExpress />
        </div>
        <div id="liquidshipping">
          <LiquidShipping />
        </div>
        <div id="studentexpress">
          <StudentExpress />
        </div>
        <div id="attestationservices">
          <AttestationServices />
        </div>
        <div id="ticketingservices">
          <TicketingServices />
        </div>
        <div id="retail_cod">
          <COD />
        </div>
        <div id="paymentsolution">
          <PaymentSolution />
        </div>
        <div id="shipmentinsurance">
          <ShipmentInsurance />
        </div>
        <div id="tcsfresh">
          <TCSFresh />
        </div>
        <div id="ecomsolution">
          <EcomSolution />
        </div>
        <div id="mms">
          <MMS />
        </div>
        <div id="overlandexpress">
          <OverlandExpress />
        </div>
        <div id="Warehousing">
          <Warehouse />
        </div>
        <div id="distribution">
          <Distribution />
        </div>
        <div id="pack-n-go">
          <PackNGO />
        </div>
        <div id="coldchain">
          <ColdChain />
        </div>
      </div>
    </div>
  );
};
export default Domestic;
